import AnswerFactory from '../answer_factory'
import FormValidator from './validators/form_validator'

document.addEventListener("turbolinks:load", function () {

  if (isAppliedFormView()) {

    document.querySelector('#btn-save-new-form').addEventListener('click', (event) => {
      event.preventDefault()
      const questionCards = document.querySelectorAll('.question')

      if (new FormValidator().isValid()){
        const answers = Array.from(questionCards).map(questionCard => {
          return new AnswerFactory(questionCard).build()
        })
        const authToken = document.getElementsByTagName('meta')[2].content
        axios.post('/saas/answers', { answers }, { headers: { 'X-CSRF-Token': authToken } })
          .then(response => {
            const appliedFormId = response.data.applied_form_id
            const currentUrl = window.location.href
            const baseUrl = currentUrl.split('/new')[0]
            window.location.replace(`${baseUrl}/${appliedFormId}`)
          })
          .catch(error => console.log(error))
      }
    })
  }
})

function isAppliedFormView() {
  return document.getElementById('new-applied-form')?.length > 0
}
